import React, { useState } from "react";

const PaginatedList = ({
  data = [],
  pageSizes = [5, 10, 25],
  children,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(pageSizes[0]);

  const totalRecords = data.length;
  const totalPages = Math.ceil(totalRecords / recordsPerPage);

  const startEntry = totalRecords === 0 ? 0 : (currentPage - 1) * recordsPerPage + 1;
  const endEntry = Math.min(startEntry + recordsPerPage - 1, totalRecords);

  const currentData = data.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  const handleChangePage = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handlePageSizeChange = (e) => {
    setRecordsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  return children({
    data: currentData,
    currentPage,
    totalPages,
    totalRecords,
    startEntry,
    endEntry,
    recordsPerPage,
    handleChangePage,
    handlePageSizeChange,
  });
};

export default PaginatedList;


